module.exports = __webpack_public_path__ + "img/banner.f76b070.webp";